export default __webpack_public_path__ + "static/media/backwardComputation.6427121a.svg";